import { AddressType } from 'generated/graphql';
import { isNilOrEmpty, IStatusable } from 'helpers';
import { addressHasGoodGeocode } from './address-has-good-geocode';

interface IAddrBaseInput extends IStatusable {
  latitude: number;
  longitude: number;
  addressType: AddressType;
  streetAddress: string;
  geocodeSource: string;
  geocodeBad: boolean;
}

export function removeUnmappableAddresses
  <T extends IAddrBaseInput>(addresses: Array<T>): Array<T> {
  return (addresses || [])
    .filter(a => a.addressType !== AddressType.Mailing)
    .filter(a => addressHasGoodGeocode(a))
    .filter(a => {
      if (isNilOrEmpty(a.streetAddress)) {
        return a.geocodeSource === 'user_added';
      }

      return true;
    });
}
